import PutEmailTemplateNameModal from './PutEmailTemplateNameModal';

export default PutEmailTemplateNameModal;
